module.exports = __webpack_public_path__ + "media/images/button_PlayNext-093f7ecf34dbf4614af5c1a34fb4e90d.png";